import { acceptedFileFormats } from '@constants/URLs';
import styled from '@emotion/styled';
import { faCloudArrowUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

/* istanbul ignore next */
export function Header() {
  const { t } = useTranslation('uploads');

  return (
    <Rows>
      <div style={{ fontSize: '1.5rem', display: 'flex', gap: '0.5rem' }}>
        <FontAwesomeIcon icon={faCloudArrowUp} size="lg" />
        {t('uploads')}
      </div>
      <Columns>
        <div>
          <Typography fontWeight={600}>{t('welcomeToUploadsPage')}</Typography>
          <Typography>
            <Trans ns="uploads" i18nKey="pageDescription">
              On this page you can upload files such as: 3D files (check the{' '}
              <Link target="_blank" href={acceptedFileFormats}>
                accepted CAD File Formats
              </Link>
              ), instruction manuals, BOM data, PDFs, and spreadsheets, which all assist us in creating your Parts
              Catalogue or Work Instructions.
            </Trans>
          </Typography>
        </div>
      </Columns>
    </Rows>
  );
}

const Rows = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const Columns = styled('div')`
  display: flex;
  flex-direction: row;
`;

const Link = styled('a')`
  text-decoration: underline;
`;
